import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import { DailyExpenseDay } from "../../types/daily-expense.type";
import { todayInBangkok } from "../../utils/date";
import { API_DATE_FORMAT, EMPTY_CELL_TEXT } from "./constants";
import { isSentBack, readOnlyNoticeOf } from "./dailyExpenseStatus";
import { formatTimestamp } from "./format";

interface DayBannersProps {
  day: DailyExpenseDay;
  /** Fields at fault after a save attempt; 0 hides the banner. */
  errorCount: number;
}

/**
 * The lines at the top of the S2 form: head office's send-back with its reason, the fields a save
 * refused, and why a day the branch cannot change is read-only.
 */
export default function DayBanners({ day, errorCount }: Readonly<DayBannersProps>) {
  const notice = readOnlyNoticeOf(
    day,
    todayInBangkok().format(API_DATE_FORMAT),
    formatTimestamp,
  );
  const document = day.document;

  return (
    <Stack gap={1.5}>
      {document && isSentBack(day) && (
        <Alert severity="error">
          <AlertTitle>
            ถูกตีกลับโดย {document.reviewed_by_name ?? EMPTY_CELL_TEXT} ·{" "}
            {formatTimestamp(document.reviewed_at)}
          </AlertTitle>
          เหตุผล: {document.reject_reason ?? EMPTY_CELL_TEXT}
        </Alert>
      )}
      {errorCount > 0 && (
        <Alert severity="error">
          พบข้อมูลไม่ถูกต้อง {errorCount} ช่อง · แก้ช่องที่มีกรอบสีแดงก่อนบันทึก
        </Alert>
      )}
      {notice && <Alert severity={notice.severity}>{notice.text}</Alert>}
    </Stack>
  );
}
